import { render } from "./ManageWorkspaces.vue?vue&type=template&id=bc3c1788&scoped=true"
import script from "./ManageWorkspaces.vue?vue&type=script&lang=js"
export * from "./ManageWorkspaces.vue?vue&type=script&lang=js"

import "./ManageWorkspaces.vue?vue&type=style&index=0&id=bc3c1788&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3c1788"]])

export default __exports__